export const getStateByContainerId = containerId => rootState => {
    return rootState[containerId];
};
